module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/y7R6wB/tc-custom/9781467440349.jpg?1728069159623",
      "alt": "This image is the cover for the book Distance in Preaching"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Distance in Preaching\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Based on several years of teaching and careful observation in preaching classes, this book by Michael Brothers explores the benefits of \"distance\" in preaching -- and listening to -- sermons."), _c('br'), _c('br'), _vm._v("Having noticed that sermon listeners generally want to be given room for their own interpretations and experiences, Brothers argues that critical and aesthetic "), _c('i', [_vm._v("distance")]), _vm._v(" as a hermeneutical tool is vital to hearing the gospel today and should be intentionally employed in sermon construction and delivery. He explains this \"distance\" in the field of homiletics, equips teachers and students of preaching to evaluate the function of distance in sermons, and encourages preachers to practice the use of distance in their preaching.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Brothers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael A. Brothers is associate professor of speech communication in ministry at Princeton Theological Seminary.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0